// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-20T04:48:16.856Z
// Property: Metropolitan (ID: 6767906449167856)
// Collections: 69 amenities, 32 floorplans (live), 23 photos, 25 POIs, 5 reviews, 11 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162483",
  "multihub_property_id": "6767906449167856",
  "property_external_id": "924380",
  "property_zillow_url": "https://www.zillow.com/apartments/oklahoma-city-ok/metropolitan/65bPDn/",
  "property_apartments_url": "https://www.apartments.com/metropolitan-oklahoma-city-ok/rbfywr2",
  "property_google_business_url": "https://www.google.com/maps/place/Metropolitan/data=!4m2!3m1!1s0x0:0xdcb5497e83640061?sa=X&ved=2ahUKEwiMuJjMjbmSAxVJmGoFHVCDJygQ_BJ6BAgTEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "metropolitan",
  "property_name": "Metropolitan",
  "property_website_url": "https://www.metropolitanokc.com/",
  "property_domain": "https://www.metropolitanokc.com/",
  "property_address": "800 N. Oklahoma Ave.",
  "property_full_address": "800 N Oklahoma Ave, Oklahoma City, OK 73104",
  "property_address_1": "800 N Oklahoma Ave",
  "property_address_2": null,
  "property_address_city": "Oklahoma City",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "73104",
  "property_address_country": "US",
  "property_address_county": "Oklahoma County",
  "property_neighborhood_address": "Central Oklahoma City",
  "property_address_latitude": "35.4751666",
  "property_address_longitude": "-97.5100033",
  "property_email": "metropolitan@weidner.com",
  "property_phone": "4057833559",
  "property_call_tracking_phone": "405-759-4863",
  "property_company_name": "Lineups, inc",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Downtown OKC energy meets loft-style living.</strong> Explore studio to three-bedroom apartments and two-story lofts at Metropolitan, where oversized windows, polished finishes, included garage parking, and resort-style community spaces put bold city living right at home—then schedule your tour.</p>",
  "property_long_description": "<p><strong>Downtown OKC energy, Automobile Alley character.</strong> At Metropolitan, you live in one of Oklahoma City’s most recognizable urban districts, where restored auto-era storefronts, neon signs, murals, breweries, boutiques, and destination dining line the blocks around Broadway. From here, the Downtown Business District, Bricktown, Deep Deuce, Midtown, the Boathouse District, Scissortail Park, and the OKC Streetcar are all part of your everyday map—close enough for coffee runs, dinner plans, and weekend exploring.</p><p>Choose from studio, one-, two-, and three-bedroom layouts, including spacious two-story lofts, with polished details like lofty ceilings, oversized windows, stainless steel appliances, quartz kitchen countertops, granite bath vanities, walk-in closets, in-home washers and dryers, and included garage parking. Beyond your door, community amenities bring a resort-style rhythm to city living with a saltwater pool with underwater sound, roof terrace, cabanas, grills, fitness center with yoga/spin space, resident lounge, pet play area and washing station, EV charging, controlled access, and door-to-door trash pickup.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1557e-6f09-74df-82ff-205bd6b84018.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior of a building with large windows and a patio with a hanging swing chair.",
    "public_id": "01a1557e-6f09-74df-82ff-205bd6b84018",
    "storage_key": "property/6767906449167856/01a1557e-6f09-74df-82ff-205bd6b84018.webp",
    "width": 2240,
    "height": 2240
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "329",
  "property_year_built": "2016",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "92.40121580547113",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "250",
  "property_pet_deposit": "250",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://metropolitanokc.securecafe.com/onlineleasing/metropolitan-3/floorplans.aspx",
  "property_resident_portal_url": "https://metropolitanokc.securecafenet.com/residentservices/metropolitan-3/userlogin",
  "property_apply_now_url": "https://metropolitanokc.securecafe.com/onlineleasing/metropolitan-3/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5669817071697920/019d01a0-e6bd-770e-b681-118e4aa107cd.webp",
  "property_primary_logo_media": null,
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5669817071697920/019d01a0-e69b-752d-8b60-ea16f0f1ae94.webp",
  "property_secondary_logo_media": null,
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5669817071697920/019d01a0-efe8-775f-addb-d83ffeab6926.webp",
  "property_icon_media": null,
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5669817071697920/019d01a0-efe8-775f-addb-d83ffeab6926.webp",
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5669817071697920/019d01a1-54e1-7429-9599-0a1efdb1e595.webp",
  "property_mono_white_logo_media": null,
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5669817071697920/019d01a1-6164-77db-9dbc-d7882823d590.webp",
  "property_mono_black_logo_media": null,
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto/company/5767906449162483/01a145b4-3f43-765a-9a01-c3774f6c2559.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#212222",
  "property_secondary_color": "#27C2FD",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 3",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 3",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "3",
  "property_sqft_range": " - 1558",
  "property_sqft_min": "679",
  "property_sqft_max": "1558",
  "property_price_range": "1288 - 4240",
  "property_price_min": "1288",
  "property_price_max": "4240",
  "property_available_units": 57,
  "property_facebook_url": "https://www.facebook.com/TheMetropolitanApartmentHomes",
  "property_instagram_url": "https://www.instagram.com/metropolitanaptsokc/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJYwcX1UgZsocRYQBkg35Jtdw",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Metropolitan",
  "property_home_romance_title": "Create Cherished Memories in Your Dream Apartment Community",
  "property_home_amenities_blurb": "<p><strong>Amenities that make every day easier.</strong> Metropolitan pairs a 24-hour fitness center and yoga/spin room with a saltwater pool featuring underwater sound, cabanas, grills, lounge spaces, and a roof terrace for open-air downtime. Controlled access, climate-controlled corridors, EV charging, garage parking, door-to-door trash pickup, and on-site maintenance keep the details running smoothly, while pet-friendly perks include a dog park and washing station.</p>",
  "property_home_floorplans_blurb": "<p><strong>Find your fit in Central Oklahoma City.</strong> Metropolitan offers one- and two-bedroom floor plans with open living areas, well-equipped kitchens, generous closets, and polished finishes like stainless steel appliances, quartz or granite-style surfaces, oversized windows, and in-home laundry. Select layouts add balconies, vaulted ceilings, kitchen islands, or standout city views—browse featured plans, then explore the full collection to compare pricing and availability.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture life at Metropolitan.</strong> Preview bright kitchens with generous islands, stainless appliances, oversized-window living spaces, and polished baths with double vanities in select homes. Then look beyond your door to poolside cabanas, sleek fitness and spin spaces, a game room, resident lounge, and open-air spots with views above Central Oklahoma City.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Downtown OKC starts at your door.</strong> From Metropolitan, streetcar stops, Automobile Alley restaurants and murals, Deep Deuce history, and Bricktown’s canal-side dining and nightlife are all close by.</p><p>Catch a game at Chickasaw Bricktown Ballpark, head toward Scissortail Park or Paycom Center, or keep it local with coffee, breweries, patios, and Factory Obscura. Explore the map to see what’s around Metropolitan.</p>",
  "property_home_reviews_blurb": "<p><strong>Metropolitan earns its praise in the details.</strong> Reviews often call out kind front desk service, responsive maintenance, thoughtful follow-up, and the “great service and attention to detail” that make everyday living easier.</p><p>Residents also point to clean, well-kept spaces, spacious apartments, monthly community events, and a Central Oklahoma City location with plenty close by. Read the reviews to see what stands out most.</p>",
  "property_neighborhood_blurb": "<p><strong>Put OKC at street level.</strong> From Metropolitan, Central Oklahoma City opens in every direction: neon-lit Broadway, Automobile Alley restaurants and murals, Deep Deuce jazz history, and Bricktown’s canal, Chickasaw Bricktown Ballpark, dining, and nightlife are all part of the everyday backdrop.</p><p>Hop the OKC Streetcar for an easy ride to Midtown, Scissortail Park, Paycom Center, and downtown offices, or keep the evening close with nearby coffee, breweries, patio spots, and immersive art at Factory Obscura. Explore the map below to find your next favorite stop, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Metropolitan connects polished apartment living with the best of downtown OKC.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenity-rich living without the extra friction.</strong> At Metropolitan, your routine gets upgraded at every turn: start with a 24-hour fitness center, dedicated yoga/spin room, and saltwater pool with underwater sound, then move to cabanas, grills, lounge spaces, and a roof terrace made for easy downtime. Everyday conveniences keep pace, too, with controlled access, climate-controlled corridors, door-to-door trash pickup, EV charging, garage parking, on-site maintenance, and pet-friendly perks like a dog park and washing station.</p><p>Inside, select homes add dramatic vaulted ceilings, oversized windows, in-home washer/dryer, walk-in closets, sleek stainless appliances, and polished kitchen and bath finishes. Browse the <a href=\"/gallery\">amenity photos</a>, compare available <a href=\"/floor-plans\">floor plans</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Metropolitan brings comfort and convenience together in Central Oklahoma City.</p>",
  "property_applynow_blurb": "<p><strong>Start your application at The Metropolitan.</strong> Choose from pet-friendly studio, 1, 2, and 3 bedroom apartments and townhomes with modern kitchens, stainless steel appliances, granite countertops, in-unit laundry, and ample storage. With easy access to US-77 and OKC dining, shops, and recreation, applying online is the next step toward home.</p>",
  "property_contactus_blurb": "<p><strong>Have questions? Contact The Metropolitan leasing team.</strong><br>Ask about pet-friendly studio, 1, 2, and 3 bedroom apartments and townhomes, modern finishes, community amenities, or getting here near US-77. The team is ready to help with details, directions, and next steps for luxury apartment living in Oklahoma City.</p>",
  "property_faqs_blurb": "<p><strong>Questions about The Metropolitan?</strong> Find quick answers about our pet-friendly studio, 1, 2, and 3 bedroom apartments and townhomes, leasing details, modern finishes, community amenities, parking, and everyday conveniences. If anything else comes up, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Choose the space that matches your day-to-day.</strong> Metropolitan’s floor plans give you a wide range of one- and two-bedroom options in Central Oklahoma City, from streamlined layouts to expansive residences with room to stretch out. Compare city-inspired plans with open living areas, well-equipped kitchens, generous closet space, and select extras like balconies, vaulted ceilings, or standout views.</p><p>Inside, details such as stainless steel appliances, quartz or granite-style finishes, oversized windows, in-home laundry, and available kitchen islands make each layout feel polished and practical. Browse the cards below for current pricing and availability, explore more <a href=\"/amenities\">apartment features</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see which Metropolitan floor plan feels like yours.</p>",
  "property_gallery_blurb": "<p><strong>See Metropolitan from every angle.</strong> Browse photos that bring the community into focus: bright kitchens with generous islands and stainless appliances, airy living rooms framed by oversized windows, and polished baths with double vanities in select homes.</p><p>Move from apartment interiors to the places that shape your day—poolside loungers and cabanas, a sleek fitness and spin setting, game-room moments, resident lounge seating, and outdoor spaces made for an easy pause above Central Oklahoma City. Like what you see? Explore more <a href=\"/amenities\">community amenities</a>, compare <a href=\"/floor-plans\">available layouts</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the details in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore The Metropolitan on the map.</strong> Find available studio, 1, 2, and 3 bedroom apartments and townhomes, then see how close you are to US-77, OKC shops, restaurants, vibrant neighborhoods, parks, and golf courses—all from one interactive view.</p>",
  "property_pets_blurb": "<p><strong>Pet-friendly living with the details handled.</strong> At Metropolitan, cats and dogs are welcome under the community’s pet policy, with daily conveniences that make apartment life easier: an on-site pet play area/dog park for quick outdoor time, a pet washing station for post-walk cleanup, and elevator access that keeps coming and going simple.</p><p>When you want a bigger change of scenery, downtown green spaces and nearby pet services are close by in Central Oklahoma City. Explore more <a href=\"/amenities\">pet-friendly amenities</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Metropolitan helps make life with your pet feel polished, practical, and connected.</p>",
  "property_referafriend_blurb": "<p><strong>Share The Metropolitan lifestyle.</strong> Invite a friend to discover luxury apartments and townhomes in Oklahoma City with modern kitchens, in-unit laundry, ample storage, pet-friendly living, and easy comforts like underground parking and valet trash. Send a referral today and let them see why The Metropolitan stands out.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at The Metropolitan</strong><br>Keep luxury apartment living easy. Log in to pay rent, submit maintenance requests, and manage your account—all in one convenient place, with the same effortless living that includes in-unit laundry, ample storage, underground parking, and valet trash services.</p>",
  "property_reviews_blurb": "<p><strong>See why residents rave about Metropolitan.</strong> In reviews, you’ll notice recurring praise for the people who keep things running: kind front desk service, responsive maintenance, and follow-up that leaves an impression—“Great service and attention to detail!”</p><p>Residents also highlight a welcoming atmosphere, monthly community events, clean and well-kept spaces, spacious apartments, and a Central Oklahoma City location with plenty nearby. As you browse the ratings and comments, you’ll get a real sense of what day-to-day living at Metropolitan feels like from the people who have called it home.</p>",
  "property_created_at": "1792430948614",
  "property_scheduletour_blurb": "<p><strong>See The Metropolitan up close.</strong> Tour pet-friendly studio, 1, 2, and 3 bedroom apartments and townhomes with modern kitchens, stainless steel appliances, granite countertops, in-unit laundry, and smart storage—then picture daily life with a saltwater pool, fitness center, yoga studio, underground parking, and more. Schedule your tour today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you for reaching out!</strong> Your inquiry has been received, and The Metropolitan leasing team will follow up soon. In the meantime, picture life with modern kitchens, in-unit laundry, ample storage, and easy access to Oklahoma City shops, restaurants, recreation, and commuting routes.</p>",
  "property_virtualtours_blurb": "<p><strong>Preview the atmosphere before you arrive.</strong> Start with the Metropolitan Apartments community virtual tour and move through the shared spaces that shape the experience in Central Oklahoma City, from polished lounge areas and fitness-focused amenities to outdoor settings made for an easy pause. As you click through, notice the scale, finishes, natural light, and flow—the details that photos can’t always show.</p><p>Use the tour to narrow what matters most, then compare <a href=\"/amenities\">community features</a>, browse the <a href=\"/gallery\">photo gallery</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> when you’re ready to see Metropolitan in person.</p>",
  "property_copyright": "2026 All Rights Reserved. Metropolitan",
  "property_seo_title_home": "Metropolitan |  Apartments in Oklahoma City, OK",
  "property_seo_description_home": "Experience luxury living at Metropolitan in OKC! Choose from spacious 1 & 2-bedroom apartments with top-notch amenities and community activities.",
  "property_seo_title_floorplans": "Floor Plans | Oklahoma City, OK Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Metropolitan in Oklahoma City! Choose from stylish one- or two-bedroom floor plans designed for comfort. Your perfect home awaits!",
  "property_seo_title_amenities": "Amenities | Oklahoma City, OK Apartments for Rent",
  "property_seo_description_amenities": "Experience upscale living at Metropolitan in OKC! Enjoy modern apartments, 24/7 access, pet-friendly spaces, and exclusive amenities.",
  "property_seo_title_gallery": "Gallery | Apartments in Oklahoma City, OK",
  "property_seo_description_gallery": "Experience luxury living at Metropolitan in Oklahoma City! With stunning floor plans, premium amenities, and a vibrant community, picture your life here today!",
  "property_seo_title_virtualtours": "Virtual Tours | Metropolitan Apartments",
  "property_seo_description_virtualtours": "Experience the vibrant lifestyle at Metropolitan in Oklahoma City. Take a virtual tour of our modern one and two-bedroom apartments today!",
  "property_seo_title_interactivemap": "Interactive Map | Metropolitan Apartments",
  "property_seo_description_interactivemap": "Find your perfect apartment at Metropolitan in OKC! Check our interactive map to explore diverse floor plans, amenities, and your future home today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Oklahoma City, OK",
  "property_seo_description_neighborhood": "Uncover the vibrant neighborhood of Metropolitan in Oklahoma City! Dive into local favorites, parks, and entertainment just steps from your new home.",
  "property_seo_title_contact": "Contact Us | Metropolitan",
  "property_seo_description_contact": "Connect with our leasing team at Metropolitan in Oklahoma City, OK! Inquire about our one and two bedroom floor plans and find your perfect home today!",
  "property_seo_title_faqs": "FAQs | Apartments in Oklahoma City, OK",
  "property_seo_description_faqs": "Got questions about life at Metropolitan in OKC? Our FAQs cover everything from floor plans to amenities. Dive in and find your perfect fit today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Oklahoma City, OK",
  "property_seo_description_reviews": "Discover life at Metropolitan in OKC! Enjoy luxury amenities, diverse floor plans, and vibrant social events. Read resident reviews!",
  "property_seo_title_applynow": "Apply Now | Apartments in Oklahoma City, OK",
  "property_seo_description_applynow": "Experience luxury living at Metropolitan in Oklahoma City! Unique floor plans, unmatched amenities, and a vibrant community await. Lease your new home today!",
  "property_seo_title_residentaccess": "Resident Access | Metropolitan",
  "property_seo_description_residentaccess": "Unlock convenience at Metropolitan OKC! Access your resident portal for easy rent payments, maintenance requests, and community updates—all in one place!",
  "property_seo_title_referafriend": "Refer A Friend | Metropolitan",
  "property_seo_description_referafriend": "Refer a friend to Metropolitan in OKC and turn great friendships into great neighbors. Share the charm of community living with someone special today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Metropolitan",
  "property_seo_description_scheduletour": "Experience urban living at Metropolitan in Oklahoma City. Book your tour today and envision your new home in our vibrant community filled with amenities!",
  "property_seo_title_privacy": "Privacy Policy | Metropolitan",
  "property_seo_description_privacy": "Protecting your data is our priority at Metropolitan in Oklahoma City. Read our privacy policy to learn how we safeguard your personal information.",
  "property_seo_title_accessibility": "Website Accessibility | Metropolitan",
  "property_seo_description_accessibility": "At Metropolitan in Oklahoma City, we prioritize digital inclusion. Experience seamless accessibility designed for all. Join our community today and thrive!",
  "property_seo_title_sitemap": "Sitemap | Metropolitan",
  "property_seo_description_sitemap": "Unravel the charm of Metropolitan in Oklahoma City! Navigate our sitemap for a glimpse into your future home and the vibrant lifestyle that awaits.",
  "property_seo_title_thankyou": "Thank You | Metropolitan",
  "property_seo_description_thankyou": "Thank you for reaching out to Metropolitan in Oklahoma City! Our team will connect soon to help you find your perfect home. Exciting living awaits!",
  "property_seo_title_pets": "Pet Policy | Apartments in Oklahoma City, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1792435870966",
  "amenities": [
    {
      "id": "ec_d35e8cc547bf784aa9b44da5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378504",
      "title": "24 Hour Availability",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f77e3a08a061fbc97639fe1b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378505",
      "title": "Controlled Access Building",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_24c9df1d216b68ef3954dd49",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378506",
      "title": "On-site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3e413142a7beb1247ab06119",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378507",
      "title": "On-site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fab5c7aa2ac13e33b291fe3e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378511",
      "title": "Courtesy Patrol",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_598d4e08cb4d6bbe04cbb6d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378516",
      "title": "Boardroom",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-7e97-77aa-a5f6-82a81d399eee.webp",
      "amenity_image_media": {
        "alt_text": "A modern common area with pink chairs and a colorful rug.",
        "public_id": "01a1553a-7e97-77aa-a5f6-82a81d399eee",
        "storage_key": "property/6767906449167856/01a1553a-7e97-77aa-a5f6-82a81d399eee.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "a dining room with a round table and pink chairs",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f60d80a69b6bbab7f33b5aac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378517",
      "title": "Elevator",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_94000cb35847eb463db148f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378518",
      "title": "Reserveable Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-7e99-72aa-9f30-dc036ba8dcaa.webp",
      "amenity_image_media": {
        "alt_text": "Communal lounge with shuffleboard, pool table, TVs, and seating.",
        "public_id": "01a1553a-7e99-72aa-9f30-dc036ba8dcaa",
        "storage_key": "property/6767906449167856/01a1553a-7e99-72aa-9f30-dc036ba8dcaa.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "a large living room with a shuffleboard table and three televisions",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2cf0caa251161b04a02d459f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378528",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2f57d39e6991b5d4fa7704b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378529",
      "title": "Barbecue/Grill Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-7e9d-731a-b809-f425cec9cc03.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor kitchen and seating area with pool in the background.",
        "public_id": "01a1553a-7e9d-731a-b809-f425cec9cc03",
        "storage_key": "property/6767906449167856/01a1553a-7e9d-731a-b809-f425cec9cc03.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "a patio with a rocking chair and a pool in front of an apartment building",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_404fca4eca11328cb2ab9183",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378532",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-7e96-7497-aa7a-139a61535a5d.webp",
      "amenity_image_media": {
        "alt_text": "Gym with cardio machines and weightlifting equipment",
        "public_id": "01a1553a-7e96-7497-aa7a-139a61535a5d",
        "storage_key": "property/6767906449167856/01a1553a-7e96-7497-aa7a-139a61535a5d.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "the estates at tanglewood|fitness center",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b995232f8245e58d877d887c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378533",
      "title": "Free Weights",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1b1a577a8b7091bf6fed11bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378534",
      "title": "Salt Water Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-7d13-75ca-8ebd-3dd6f93446e4.webp",
      "amenity_image_media": {
        "alt_text": "Courtyard swimming pool with lounge chairs at a modern apartment building.",
        "public_id": "01a1553a-7d13-75ca-8ebd-3dd6f93446e4",
        "storage_key": "property/6767906449167856/01a1553a-7d13-75ca-8ebd-3dd6f93446e4.webp",
        "width": 427,
        "height": 285
      },
      "amenity_image_alt_text": "a swimming pool next to an apartment building",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d72e3ef2c35d4b3033b50efa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378543",
      "title": "Dry Cleaning Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_036a9e777a43ea8a47161b25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "88111165",
      "title": "Community of the Year",
      "amount": "false",
      "description": "2018 & 2021 Winner",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_88c304a659023901d116db2e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378547",
      "title": "Climate Controlled and Carpeted Hallways",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_14c92b76ca39c76376f665e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86656737",
      "title": "Fiber Internet Availability",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_53ecfdfa23cc4e7953e09a60",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378510",
      "title": "Corporate Suites",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fe5a154c85893a02330a62a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378513",
      "title": "Planned Social Activities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_49f9e0332bbd16943aed543d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378514",
      "title": "Trash Pickup - Door to Door",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5fdf43f5cadb0ae58382ff1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378515",
      "title": "Courtesy Patrol",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b31e6a5c20540a95f1aa09ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378519",
      "title": "Coffee Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_409b45494e33cb1ea17d2334",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378521",
      "title": "Disposal Chutes",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_291f9053b2008f0f41c95b0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378522",
      "title": "Electric Car Charging Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_472ad7c9850c33d8ca324e62",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378523",
      "title": "Gameroom",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-878e-7028-822a-573f64ef432b.webp",
      "amenity_image_media": {
        "alt_text": "Lounge area with a pool table, seating, and a long table.",
        "public_id": "01a1553a-878e-7028-822a-573f64ef432b",
        "storage_key": "property/6767906449167856/01a1553a-878e-7028-822a-573f64ef432b.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "a pool table in the clubhouse at ascend at woodbury new luxury apartments in woodbury m",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f5b5ee437a08c3fb5a7baf63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378525",
      "title": "Pet Washing Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b6b7db87df04df16723ec25f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378526",
      "title": "Resident Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-8bab-741c-a700-7b1af3a348cd.webp",
      "amenity_image_media": {
        "alt_text": "Modern communal kitchen area with stainless steel appliances, marble countertops, and contemporary lighting.",
        "public_id": "01a1553a-8bab-741c-a700-7b1af3a348cd",
        "storage_key": "property/6767906449167856/01a1553a-8bab-741c-a700-7b1af3a348cd.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "an open kitchen with a large island with a sink and dishwasher",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_492ff093c8f08f61165ae88e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378530",
      "title": "Cabana/Gazebo",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3f0cb7b1f927d95363ac7b68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378531",
      "title": "Pet Play Area/ Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-8ed1-7328-a5e8-bb46cada92f0.webp",
      "amenity_image_media": {
        "alt_text": "Dog park area with benches and trees",
        "public_id": "01a1553a-8ed1-7328-a5e8-bb46cada92f0",
        "storage_key": "property/6767906449167856/01a1553a-8ed1-7328-a5e8-bb46cada92f0.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "a grassy area with trees and a fence in the background",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_385b395cdc626338d4462660",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378535",
      "title": "Cardio Machines",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a3bc3bba6029b0de6edc4f95",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378536",
      "title": "Fitness Programs/Classes",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4fa724382dc644ae2fbd3bbe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378537",
      "title": "Weight Machines",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_455425b053d5675e8727af43",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378538",
      "title": "Yoga Studio/Spin Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-8f28-72db-b739-7175ce4dc2d2.webp",
      "amenity_image_media": {
        "alt_text": "Spin bikes and TRX suspension trainers in a modern fitness center.",
        "public_id": "01a1553a-8f28-72db-b739-7175ce4dc2d2",
        "storage_key": "property/6767906449167856/01a1553a-8f28-72db-b739-7175ce4dc2d2.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "the apartments at masse corner 205 fitness room",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bd85dbf2daabef887e9bcdf0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378540",
      "title": "Pool Table",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d187046f53d0163618adb59c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378541",
      "title": "Shuffle Board",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9616d6a80c72ef9e980fe084",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378542",
      "title": "Foosball Table",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4e561673a47548f9d3eeb15b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378546",
      "title": "Rapid Rise Garage Gate",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f91da95c0118f0af67797509",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "124800154",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_01116f57e1bc36c2d3cf3d00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378545",
      "title": "Vending Machines with 24 Hour Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bac650b9d92565555067bb3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378548",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_17bbeeb468e84724842eff0e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378549",
      "title": "Garbage Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f16b7546412b63314ecece03",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378550",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_66afcea83d6e73fbb98ec977",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378551",
      "title": "Energy Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-9028-765a-8e8d-acda76885cb7.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and dark wood cabinets.",
        "public_id": "01a1553a-9028-765a-8e8d-acda76885cb7",
        "storage_key": "property/6767906449167856/01a1553a-9028-765a-8e8d-acda76885cb7.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "a modern kitchen with stainless steel appliances and wooden cabinets",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_004ef2119921b0522b614e67",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378556",
      "title": "Central AC and Heating per apartment",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3f0804df3d1fd8dec7bda25d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378558",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-9343-715f-a612-19a84b251672.webp",
      "amenity_image_media": {
        "alt_text": "Modern bedroom with a king-size bed, dresser, and large window.",
        "public_id": "01a1553a-9343-715f-a612-19a84b251672",
        "storage_key": "property/6767906449167856/01a1553a-9343-715f-a612-19a84b251672.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "a bedroom with a large window and a ceiling fan",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c9c58f5197828ea6fe979b75",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378559",
      "title": "Patio/Balcony*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_79d1f0294ef668ac5cb78c26",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378560",
      "title": "Vaulted Ceiling*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_50228ad6d1e012f10362ae8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378561",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_24ccb34e8e2a4dd650a4d0fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378563",
      "title": "Linen Closet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4681373180889f9e58148110",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378552",
      "title": "Ice Maker",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ba024d65c9da894c96297424",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378553",
      "title": "Kitchen Island",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-99d3-743b-b7f4-4914140e7c9d.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with island, stainless steel appliances, and dark wood cabinetry.",
        "public_id": "01a1553a-99d3-743b-b7f4-4914140e7c9d",
        "storage_key": "property/6767906449167856/01a1553a-99d3-743b-b7f4-4914140e7c9d.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "a kitchen with a large island and stainless steel appliances",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_987959262a2c7bd884d0c5d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378554",
      "title": "Pantry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2f73f7523ee38d60ea2772f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378555",
      "title": "Trash Compactor",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ee4104e44cbe4354ccfd2def",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378557",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_77620e994ea23bf157d57716",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378565",
      "title": "Sprinkler System",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a06a1763fd3e19e81c233f78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378566",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-9b45-75d5-b48b-06fade348b24.webp",
      "amenity_image_media": {
        "alt_text": "Modern bathroom with double vanity, granite countertops, and a separate toilet and shower area.",
        "public_id": "01a1553a-9b45-75d5-b48b-06fade348b24",
        "storage_key": "property/6767906449167856/01a1553a-9b45-75d5-b48b-06fade348b24.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "a bathroom at homewood suites by hilton houston stafford sugar land,a bathroom with a sink and a toilet in it",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ace84f2b0e765f07c08973d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "86378567",
      "title": "9 Foot Entry Doors and Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1256b62b433a587feeb7bb80",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "94560478",
      "title": "*Preinstalled WiFi with 1st Month free from Cox",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_16ba7a91e8b040abf7f558f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "126783142",
      "title": "Floor Level 3",
      "amount": "false",
      "description": "Floor Level 3",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e344ec127f3fec69172c1a7b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "121807692",
      "title": "*Only available in select homes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_48ab07e6a68e3e77cb11e0bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "126783144",
      "title": "Floor Level 4",
      "amount": "false",
      "description": "Floor Level 4",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dec6650826a4d04f9e56ec4e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "126783146",
      "title": "No Patio",
      "amount": "false",
      "description": "No Patio",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3e94bff5a518ace14afbe2d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "126783148",
      "title": "North Building",
      "amount": "false",
      "description": "North Building",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b3018718e32335a527c2fc56",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "126783150",
      "title": "Prime Lcoation 1",
      "amount": "false",
      "description": "Prime Lcoation 1",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cd0aa19ca249695868e6509b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "126783152",
      "title": "View Billboard",
      "amount": "false",
      "description": "View Billboard",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9a94bb1fba884e4f415d16b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "126783154",
      "title": "View City",
      "amount": "false",
      "description": "View City",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_367a44a91689e4639b74152f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "126783156",
      "title": "View Courtyard",
      "amount": "false",
      "description": "View Courtyard",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_99d956877f9233351dff9513",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "126783159",
      "title": "View Garage",
      "amount": "false",
      "description": "View Garage",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c517e993f3bcb4a7b50d7526",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "external_id": "126783161",
      "title": "View Pool",
      "amount": "false",
      "description": "View Pool",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_e071156d4426cb2366d9db86",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-711c-70a3-9615-9356b831ce19.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and an island with bar stools.",
        "public_id": "01a1553a-711c-70a3-9615-9356b831ce19",
        "storage_key": "property/6767906449167856/01a1553a-711c-70a3-9615-9356b831ce19.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Stunning kitchen featuring dark wood cabinetry, sleek stainless steel appliances, and a spacious island perfect for casual dining.",
      "link": "false",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and an island with bar stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_The_Metropolitan_Favorites (14).JPG"
    },
    {
      "id": "ec_6cf4610408390a5fcb413ce3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-a6d3-76f8-9491-39b35107cf8d.webp",
      "image_media": {
        "alt_text": "Living room with a daybed, coffee table, desk, and decorative ram's head wall art.",
        "public_id": "01a1553a-a6d3-76f8-9491-39b35107cf8d",
        "storage_key": "property/6767906449167856/01a1553a-a6d3-76f8-9491-39b35107cf8d.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Stylish living area featuring a daybed, coffee table, and a dedicated workspace, perfect for relaxation and productivity.",
      "link": "false",
      "alt_text": "Living room with a daybed, coffee table, desk, and decorative ram's head wall art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_The_Metropolitan_Favorites (15).jpg"
    },
    {
      "id": "ec_c744f9224adcc1d6620ed80f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-a634-7231-9ad6-9d6414e5cfe7.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island and stainless steel appliances, open to living room with large windows.",
        "public_id": "01a1553a-a634-7231-9ad6-9d6414e5cfe7",
        "storage_key": "property/6767906449167856/01a1553a-a634-7231-9ad6-9d6414e5cfe7.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Spacious and modern apartment featuring a fully equipped kitchen with a large island, stainless steel appliances, and an open-concept living area with abundant natural light.",
      "link": "false",
      "alt_text": "Modern kitchen with island and stainless steel appliances, open to living room with large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_The_Metropolitan_Favorites (34).jpg"
    },
    {
      "id": "ec_39ecdeb3c6f3c5c73ef3a701",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-a632-74bb-9d91-cb11361ea40d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and white countertops.",
        "public_id": "01a1553a-a632-74bb-9d91-cb11361ea40d",
        "storage_key": "property/6767906449167856/01a1553a-a632-74bb-9d91-cb11361ea40d.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Elegant kitchen featuring dark wood cabinetry, sleek stainless steel appliances, and pristine white countertops, perfect for culinary adventures.",
      "link": "false",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and white countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_The_Metropolitan_Favorites (16).JPG"
    },
    {
      "id": "ec_21fee9793f2dca1538e7f505",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-a62d-7724-bbcc-ab7afcb0d840.webp",
      "image_media": {
        "alt_text": "Bright home office area with a white desk and chair, and a comfortable seating area with a couch.",
        "public_id": "01a1553a-a62d-7724-bbcc-ab7afcb0d840",
        "storage_key": "property/6767906449167856/01a1553a-a62d-7724-bbcc-ab7afcb0d840.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Create your ideal workspace and relax in style in this beautifully appointed apartment. Features a dedicated home office area and a cozy living space.",
      "link": "false",
      "alt_text": "Bright home office area with a white desk and chair, and a comfortable seating area with a couch.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_The_Metropolitan_Favorites (35).jpg"
    },
    {
      "id": "ec_434bfe2c92836e80b8f2521c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-a6e3-710f-b36b-d112960e6044.webp",
      "image_media": {
        "alt_text": "Modern lobby area with seating, a kitchen island, and large windows.",
        "public_id": "01a1553a-a6e3-710f-b36b-d112960e6044",
        "storage_key": "property/6767906449167856/01a1553a-a6e3-710f-b36b-d112960e6044.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Welcome to our stylish lobby, featuring comfortable seating areas, a modern kitchen island, and abundant natural light from large windows.",
      "link": "false",
      "alt_text": "Modern lobby area with seating, a kitchen island, and large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_The_Metropolitan_Favorites (36).jpg"
    },
    {
      "id": "ec_7f78478dbfbc076f84b19e0d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-b308-74b8-b929-f876ad0ca75b.webp",
      "image_media": {
        "alt_text": "Living room and bedroom view of a luxury apartment with large windows and city views.",
        "public_id": "01a1553a-b308-74b8-b929-f876ad0ca75b",
        "storage_key": "property/6767906449167856/01a1553a-b308-74b8-b929-f876ad0ca75b.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Spacious and modern apartment living area, featuring a comfortable sofa, elegant decor, and a bright, open-concept layout with a view of the city skyline. The adjacent bedroom offers a serene retreat.",
      "link": "false",
      "alt_text": "Living room and bedroom view of a luxury apartment with large windows and city views.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_The_Metropolitan_Favorites (17).jpg"
    },
    {
      "id": "ec_110b85951242906099375de8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-b590-72f5-bf5c-8830a83eacf9.webp",
      "image_media": {
        "alt_text": "Living room with a large window overlooking a city skyline, featuring a tan leather sofa, a coffee table, and a television.",
        "public_id": "01a1553a-b590-72f5-bf5c-8830a83eacf9",
        "storage_key": "property/6767906449167856/01a1553a-b590-72f5-bf5c-8830a83eacf9.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Relax and unwind in this stylish living room, complete with a large window offering breathtaking city views. Perfect for entertaining or enjoying a quiet evening in.",
      "link": "false",
      "alt_text": "Living room with a large window overlooking a city skyline, featuring a tan leather sofa, a coffee table, and a television.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_The_Metropolitan_Favorites (18).JPG"
    },
    {
      "id": "ec_f9f7344f5a988871374aaff9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-b599-756c-b72f-d387d3999dc3.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and marble countertops.",
        "public_id": "01a1553a-b599-756c-b72f-d387d3999dc3",
        "storage_key": "property/6767906449167856/01a1553a-b599-756c-b72f-d387d3999dc3.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Experience luxury living in this beautifully appointed kitchen, featuring sleek white cabinetry, state-of-the-art stainless steel appliances, and elegant marble countertops.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and marble countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_The_Metropolitan_Favorites (19).jpg"
    },
    {
      "id": "ec_3723464aba78a1025302e86e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-b5c4-74ab-aa56-b87c059bd0ff.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a king-size bed, dresser, and large window.",
        "public_id": "01a1553a-b5c4-74ab-aa56-b87c059bd0ff",
        "storage_key": "property/6767906449167856/01a1553a-b5c4-74ab-aa56-b87c059bd0ff.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed bedroom, featuring a plush king-size bed, elegant dresser, and a large window with scenic views.",
      "link": "false",
      "alt_text": "Modern bedroom with a king-size bed, dresser, and large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_The_Metropolitan_Favorites (20).jpg"
    },
    {
      "id": "ec_39df5ad3e9ff9378594cf359",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-b79d-77dd-8371-54e4b9039b92.webp",
      "image_media": {
        "alt_text": "King-size bed with decorative pillows and a large white wall hanging.",
        "public_id": "01a1553a-b79d-77dd-8371-54e4b9039b92",
        "storage_key": "property/6767906449167856/01a1553a-b79d-77dd-8371-54e4b9039b92.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Stylish bedroom with a king-size bed, comfortable pillows, and unique wall art. Access to the en-suite bathroom and kitchen area.",
      "link": "false",
      "alt_text": "King-size bed with decorative pillows and a large white wall hanging.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_The_Metropolitan_Favorites (21).JPG"
    },
    {
      "id": "ec_b9420fcb6db42f0b9343a1f3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-c04a-7166-8eeb-ac0204f17c86.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with granite countertop, sink, faucet, and large mirror. Toilet and closet visible.",
        "public_id": "01a1553a-c04a-7166-8eeb-ac0204f17c86",
        "storage_key": "property/6767906449167856/01a1553a-c04a-7166-8eeb-ac0204f17c86.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a modern vanity with a granite countertop, ample storage, and a well-lit mirror. Includes a private toilet area and a walk-in closet.",
      "link": "false",
      "alt_text": "Bathroom vanity with granite countertop, sink, faucet, and large mirror. Toilet and closet visible.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_The_Metropolitan_Favorites (22).JPG"
    },
    {
      "id": "ec_e24c7751872bf2a5b3c809bc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-c10f-70f0-930b-faebac39e392.webp",
      "image_media": {
        "alt_text": "Double vanity bathroom with granite countertops, wood cabinets, and a separate toilet and bathtub area.",
        "public_id": "01a1553a-c10f-70f0-930b-faebac39e392",
        "storage_key": "property/6767906449167856/01a1553a-c10f-70f0-930b-faebac39e392.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Step into this well-appointed bathroom featuring a spacious double vanity with elegant granite countertops, ample storage, and a separate area for the toilet and bathtub.",
      "link": "false",
      "alt_text": "Double vanity bathroom with granite countertops, wood cabinets, and a separate toilet and bathtub area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_The_Metropolitan_Favorites (23).jpg"
    },
    {
      "id": "ec_1b5886ee0b6c1a960ef1169b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-c2c6-7640-b480-f8a80beb3c79.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and surrounding apartment buildings.",
        "public_id": "01a1553a-c2c6-7640-b480-f8a80beb3c79",
        "storage_key": "property/6767906449167856/01a1553a-c2c6-7640-b480-f8a80beb3c79.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs perfect for soaking up the sun. Enjoy resort-style living at its finest.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and surrounding apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_The_Metropolitan_Favorites (24).JPG"
    },
    {
      "id": "ec_d5a3ad791c3c80871abf69fa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-c431-749a-b847-7d86d023fc5b.webp",
      "image_media": {
        "alt_text": "Community lounge area with a pool table, shuffleboard, and seating.",
        "public_id": "01a1553a-c431-749a-b847-7d86d023fc5b",
        "storage_key": "property/6767906449167856/01a1553a-c431-749a-b847-7d86d023fc5b.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Enjoy leisure time in the community lounge, featuring a billiards table, shuffleboard, and comfortable seating areas.",
      "link": "false",
      "alt_text": "Community lounge area with a pool table, shuffleboard, and seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_The_Metropolitan_Favorites (25).JPG"
    },
    {
      "id": "ec_fc59f3db5742ece9e47fafc1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-c43f-751f-a5d2-b34a621c6b5e.webp",
      "image_media": {
        "alt_text": "Lobby and seating area with large windows and exterior view.",
        "public_id": "01a1553a-c43f-751f-a5d2-b34a621c6b5e",
        "storage_key": "property/6767906449167856/01a1553a-c43f-751f-a5d2-b34a621c6b5e.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed lobby, featuring comfortable seating and large windows with scenic views.",
      "link": "false",
      "alt_text": "Lobby and seating area with large windows and exterior view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_The_Metropolitan_Favorites (26).jpg"
    },
    {
      "id": "ec_6ed9d2670ea473b96ad17b41",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-cc88-77dc-987b-180e85948fff.webp",
      "image_media": {
        "alt_text": "Spin bikes and TRX suspension trainers in a modern fitness center.",
        "public_id": "01a1553a-cc88-77dc-987b-180e85948fff",
        "storage_key": "property/6767906449167856/01a1553a-cc88-77dc-987b-180e85948fff.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring spin bikes, TRX suspension trainers, and a mirrored wall.",
      "link": "false",
      "alt_text": "Spin bikes and TRX suspension trainers in a modern fitness center.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_The_Metropolitan_Favorites (27).JPG"
    },
    {
      "id": "ec_57489e6cb1ea580802a2314e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-cdaa-7033-bc45-d2a67dcd3194.webp",
      "image_media": {
        "alt_text": "State-of-the-art fitness center with treadmills, ellipticals, rowing machines, and weight-lifting equipment.",
        "public_id": "01a1553a-cdaa-7033-bc45-d2a67dcd3194",
        "storage_key": "property/6767906449167856/01a1553a-cdaa-7033-bc45-d2a67dcd3194.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Stay active and energized in our fully equipped fitness center, featuring a wide range of cardio machines and weight training equipment.",
      "link": "false",
      "alt_text": "State-of-the-art fitness center with treadmills, ellipticals, rowing machines, and weight-lifting equipment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_The_Metropolitan_Favorites (28).JPG"
    },
    {
      "id": "ec_f779d6b7a1ad7d74b5007008",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-cde3-714d-bcc8-0fda8361da30.webp",
      "image_media": {
        "alt_text": "Vibrant lounge area with modern furniture and motivational wall art.",
        "public_id": "01a1553a-cde3-714d-bcc8-0fda8361da30",
        "storage_key": "property/6767906449167856/01a1553a-cde3-714d-bcc8-0fda8361da30.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Gather in our stylish lounge, featuring a chic marble table, bold pink chairs, and an inspiring \"be moved\" wall decal.",
      "link": "false",
      "alt_text": "Vibrant lounge area with modern furniture and motivational wall art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_The_Metropolitan_Favorites (29).jpg"
    },
    {
      "id": "ec_a239b5e7fcc4ed69d1250b4d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-d23e-7106-aaca-eec3231fd861.webp",
      "image_media": {
        "alt_text": "Modern lobby with stylish seating areas and a reception desk with \"Metropolitan\" branding.",
        "public_id": "01a1553a-d23e-7106-aaca-eec3231fd861",
        "storage_key": "property/6767906449167856/01a1553a-d23e-7106-aaca-eec3231fd861.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Welcome to the stylish and modern lobby of Metropolitan, featuring comfortable seating, a chic reception area, and abundant natural light.",
      "link": "false",
      "alt_text": "Modern lobby with stylish seating areas and a reception desk with \"Metropolitan\" branding.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_The_Metropolitan_Favorites (30).jpg"
    },
    {
      "id": "ec_353b0bb728d57f3eb25d46f3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a15536-ef85-70fb-8e72-b54d2b4b4311.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with brick and yellow accents",
        "public_id": "01a15536-ef85-70fb-8e72-b54d2b4b4311",
        "storage_key": "property/6767906449167856/01a15536-ef85-70fb-8e72-b54d2b4b4311.webp",
        "width": 1275,
        "height": 850
      },
      "title": "Community",
      "description": "View of a modern apartment building's exterior, featuring a striking combination of brick, grey siding, and vibrant yellow architectural elements. Balconies and large windows add to its contemporary appeal.",
      "link": "false",
      "alt_text": "Modern apartment building exterior with brick and yellow accents",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_The_Metropolitan_Favorites (31).jpg"
    },
    {
      "id": "ec_330c50b5e005c1b5fccb2630",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-d68b-7259-a6ec-5bec357f0de1.webp",
      "image_media": {
        "alt_text": "The Metropolitan apartment building's modern exterior with balconies and a prominent entrance.",
        "public_id": "01a1553a-d68b-7259-a6ec-5bec357f0de1",
        "storage_key": "property/6767906449167856/01a1553a-d68b-7259-a6ec-5bec357f0de1.webp",
        "width": 1275,
        "height": 850
      },
      "title": "Community",
      "description": "Discover modern living at The Metropolitan, featuring stylish architecture and a welcoming entrance.",
      "link": "false",
      "alt_text": "The Metropolitan apartment building's modern exterior with balconies and a prominent entrance.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_The_Metropolitan_Favorites (32).jpg"
    },
    {
      "id": "ec_b8b58ca1e41bbc3c34952627",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a1553a-d951-703d-9bed-5611e4d12631.webp",
      "image_media": {
        "alt_text": "Courtyard with fountain, lounge chairs, and outdoor grills.",
        "public_id": "01a1553a-d951-703d-9bed-5611e4d12631",
        "storage_key": "property/6767906449167856/01a1553a-d951-703d-9bed-5611e4d12631.webp",
        "width": 1275,
        "height": 850
      },
      "title": "Community",
      "description": "Enjoy relaxing in the courtyard featuring a water fountain, comfortable lounge seating, and convenient outdoor grilling stations.",
      "link": "false",
      "alt_text": "Courtyard with fountain, lounge chairs, and outdoor grills.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_The_Metropolitan_Favorites (33).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_db514244-9641-4c26-9526-369136ac3c12",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "custom",
      "poi_name": "Cheever's Cafe",
      "poi_type": "Restaurants",
      "poi_address": "2409 N Hudson Ave, Oklahoma City, OK 73103",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a15543-1ea2-7619-9b77-682ce752ab95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15543-1ea2-7619-9b77-682ce752ab95",
        "storage_key": "property/6767906449167856/01a15543-1ea2-7619-9b77-682ce752ab95.webp",
        "width": 750,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/cheevers-cafe-oklahoma-city-14?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=35.49374,-97.519048",
      "poi_item_slug": "cheevers-cafe-oklahoma-city-14",
      "poi_latitude": "35.49374",
      "poi_longitude": "-97.519048",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+14055257007",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJ5w0nd04XsocRl-bkSNLRAwM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e99fd37a-30f2-4c16-b2af-65b840979ff2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "custom",
      "poi_name": "Tamashii Ramen",
      "poi_type": "Restaurants",
      "poi_address": "321 NW 8th St, Ste B, Oklahoma City, OK 73102",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a15543-2091-70b9-98cc-c4773c2bd840.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15543-2091-70b9-98cc-c4773c2bd840",
        "storage_key": "property/6767906449167856/01a15543-2091-70b9-98cc-c4773c2bd840.webp",
        "width": 1000,
        "height": 666
      },
      "poi_business_url": "https://www.yelp.com/biz/tamashii-ramen-oklahoma-city?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=35.4763325789891,-97.5187203455078",
      "poi_item_slug": "tamashii-ramen-oklahoma-city",
      "poi_latitude": "35.4763325789891",
      "poi_longitude": "-97.5187203455078",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+14055170707",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJM8u4mDEXsocRNz67NSisC1o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6be9bbe5-28b4-4b88-afee-63879af6fd58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "custom",
      "poi_name": "The Jones Assembly",
      "poi_type": "Restaurants",
      "poi_address": "901 W Sheridan Ave, Oklahoma City, OK 73106",
      "poi_short_description": "",
      "poi_long_description": "The Jones Assembly is your go-to destination for an unforgettable blend of food, spirits, and music. Located in the heart of the West Village District, we offer a unique experience with our elevated menu, craft cocktails, and vibrant atmosphere. Whether you're joining us for a casual drink, a special dinner, or a live music event, The Jones Assembly is where flavors and melodies come together. Check out our event schedule and join us for a meal or a show!",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a15543-1e9f-73ec-b5da-ede68b9bffda.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15543-1e9f-73ec-b5da-ede68b9bffda",
        "storage_key": "property/6767906449167856/01a15543-1e9f-73ec-b5da-ede68b9bffda.webp",
        "width": 750,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/the-jones-assembly-oklahoma-city?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=35.46664,-97.52739",
      "poi_item_slug": "the-jones-assembly-oklahoma-city",
      "poi_latitude": "35.46664",
      "poi_longitude": "-97.52739",
      "poi_miles_from_property": "1.13",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+14052122378",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJwcSZY9QQsocR8nsRmXIP3QI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3358042c-e54e-4c51-a32e-6f8d480ad2a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "custom",
      "poi_name": "Black Walnut ",
      "poi_type": "Restaurants",
      "poi_address": "100 NE 4th St, Oklahoma City, OK 73104",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a15543-22dd-7299-bcb0-709399b0ef98.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15543-22dd-7299-bcb0-709399b0ef98",
        "storage_key": "property/6767906449167856/01a15543-22dd-7299-bcb0-709399b0ef98.webp",
        "width": 750,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/black-walnut-oklahoma-city-2?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=35.471489,-97.509146",
      "poi_item_slug": "black-walnut-oklahoma-city-2",
      "poi_latitude": "35.471489",
      "poi_longitude": "-97.509146",
      "poi_miles_from_property": "0.24",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+14054456273",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJGwf4nkEXsocRStoux_rSxaQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_dfb415cf-6a57-4f6a-bb3e-9c356df10336",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "custom",
      "poi_name": "FRIDA southwest",
      "poi_type": "Restaurants",
      "poi_address": "500 Paseo Dr, Oklahoma City, OK 73103",
      "poi_short_description": "",
      "poi_long_description": "FRIDA southwest - inspired by the cuisine of Oklahoma, Santa Fe and northern Mexico presented in an architectural unique, beautifully curated space. A Humankind Hospitality restaurant. Paseo Arts District, OKC.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a15543-233c-746f-b9a2-4d8bd23cb8af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15543-233c-746f-b9a2-4d8bd23cb8af",
        "storage_key": "property/6767906449167856/01a15543-233c-746f-b9a2-4d8bd23cb8af.webp",
        "width": 750,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/frida-southwest-oklahoma-city-2?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=35.4985300003351,-97.5213149996807",
      "poi_item_slug": "frida-southwest-oklahoma-city-2",
      "poi_latitude": "35.4985300003351",
      "poi_longitude": "-97.5213149996807",
      "poi_miles_from_property": "1.73",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+14056837432",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJsSDoFLQXsocRWoVKCM6h3lA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6ce5d809-a95c-4e2d-bd01-47c29258b429",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "custom",
      "poi_name": "ACM@UCO Performance Lab",
      "poi_type": "Universities",
      "poi_address": "329 E Sheridan Ave, Oklahoma City, OK 73104",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a15543-1e8f-75f8-9210-826f868c9cf3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15543-1e8f-75f8-9210-826f868c9cf3",
        "storage_key": "property/6767906449167856/01a15543-1e8f-75f8-9210-826f868c9cf3.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.yelp.com/biz/acm-uco-performance-lab-oklahoma-city?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=35.465645039169004,-97.51116436390748",
      "poi_item_slug": "acm-uco-performance-lab-oklahoma-city",
      "poi_latitude": "35.465645039169",
      "poi_longitude": "-97.51116436390748",
      "poi_miles_from_property": "0.64",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+14059744700",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJwdS-AyEXsocRQ-bpd8IX1Iw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7f654b2f-9f4a-44a0-943e-0a7cc8610729",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "custom",
      "poi_name": "Rose State College",
      "poi_type": "Universities",
      "poi_address": "6420 SE 15th St, Midwest City, OK 73110",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a15543-21c0-72c8-ae53-78e2806bdb90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15543-21c0-72c8-ae53-78e2806bdb90",
        "storage_key": "property/6767906449167856/01a15543-21c0-72c8-ae53-78e2806bdb90.webp",
        "width": 750,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/rose-state-college-midwest-city?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=35.444248,-97.413729",
      "poi_item_slug": "rose-state-college-midwest-city",
      "poi_latitude": "35.444248",
      "poi_longitude": "-97.413729",
      "poi_miles_from_property": "5.82",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+14057337372",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJW2H9qcE9socRHXolJecF0uo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2e45efd4-abf1-4077-8fc9-a691a86def24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "custom",
      "poi_name": "Summit - Oklahoma City",
      "poi_type": "Gyms",
      "poi_address": "200 SE 4th St, Oklahoma City, OK 73129",
      "poi_short_description": "",
      "poi_long_description": "The Silos, a Stoneyard Climbing gym, are an indoor and outdoor rock climbing gym and fitness center on 4th Street in Oklahoma. Stoneyard Climbing's only climbing gym converted from grain silos has top rope, lead climbing, bouldering, group fitness areas, and yoga classes and our facilities are available to members and day pass visitors. With three locations across Central Oklahoma and Northwest Arkansas Stoneyard Climbing has you covered in areas of personal wellness and non-traditional exercise regimens.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a15543-2040-723f-ae26-59a1b8b9b6d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15543-2040-723f-ae26-59a1b8b9b6d7",
        "storage_key": "property/6767906449167856/01a15543-2040-723f-ae26-59a1b8b9b6d7.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.yelp.com/biz/summit-oklahoma-city-oklahoma-city-5?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=35.46017482,-97.507138",
      "poi_item_slug": "summit-oklahoma-city-oklahoma-city-5",
      "poi_latitude": "35.46017482",
      "poi_longitude": "-97.507138",
      "poi_miles_from_property": "1.03",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+14056737448",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJaccr2d4WsocRCJWGxAi8hWs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2f5f18c6-f48a-4a3c-b940-3b163436a57f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "custom",
      "poi_name": "CrossFit 405",
      "poi_type": "Gyms",
      "poi_address": "1501 N Broadway Ave, Oklahoma City, OK 73103",
      "poi_short_description": "",
      "poi_long_description": "We use CrossFit group classes, nutrition, and community to help you become the best version of yourself. Our mission is Relentless pursuit of health, happiness, and longevity.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a15543-1e31-745a-8c51-ff7f352cfbf3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15543-1e31-745a-8c51-ff7f352cfbf3",
        "storage_key": "property/6767906449167856/01a15543-1e31-745a-8c51-ff7f352cfbf3.webp",
        "width": 1000,
        "height": 668
      },
      "poi_business_url": "https://www.yelp.com/biz/crossfit-405-oklahoma-city?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=35.48407,-97.514313",
      "poi_item_slug": "crossfit-405-oklahoma-city",
      "poi_latitude": "35.48407",
      "poi_longitude": "-97.514313",
      "poi_miles_from_property": "0.68",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+14054580405",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJee3OIDIXsocRmDDzSX7vzCA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_facd5575-a238-4f7a-bf27-f3e4cebd1eb1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "custom",
      "poi_name": "University Health Club",
      "poi_type": "Gyms",
      "poi_address": "1000 N Lincoln Blvd, Oklahoma City, OK 73104",
      "poi_short_description": "",
      "poi_long_description": "Swimming Pool, Basketball, Rock Climbing, Pickleball, Volleyball, Racquetball, Squash, Cardiovascular Machines, Free Weights, Machine Weights, Olympic Weights, Locker Rooms, Steam Rooms, Dry Saunas, Café.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a15543-20eb-77f9-a748-5d7b30e06641.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15543-20eb-77f9-a748-5d7b30e06641",
        "storage_key": "property/6767906449167856/01a15543-20eb-77f9-a748-5d7b30e06641.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.yelp.com/biz/university-health-club-oklahoma-city?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=35.477348,-97.500931",
      "poi_item_slug": "university-health-club-oklahoma-city",
      "poi_latitude": "35.477348",
      "poi_longitude": "-97.500931",
      "poi_miles_from_property": "0.54",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+14052711650",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJLz1hpRcXsocRzFkB5IvVHps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_477f4b59-8191-47ee-baf3-9668d6cbec9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "custom",
      "poi_name": "CYCLEBAR",
      "poi_type": "Gyms",
      "poi_address": "5730 N Classen Blvd Suite 1 & 2, Ste 1 & 2, Oklahoma City, OK 73118",
      "poi_short_description": "",
      "poi_long_description": "CycleBar® Classen Curve is more than a ride. It’s a journey of self-discovery. With indoor cycling rides designed for all fitness levels, we promise to empower, inspire, and elevate you throughout every day.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a15543-24f8-717d-8260-d5077b867065.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15543-24f8-717d-8260-d5077b867065",
        "storage_key": "property/6767906449167856/01a15543-24f8-717d-8260-d5077b867065.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.yelp.com/biz/cyclebar-oklahoma-city?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=35.530452,-97.533889",
      "poi_item_slug": "cyclebar-oklahoma-city",
      "poi_latitude": "35.530452",
      "poi_longitude": "-97.533889",
      "poi_miles_from_property": "4.06",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+14058861223",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJPfa4x9MQsocRcY1zMB-3sus",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bdc5c201-5b89-4974-825a-0e9c3b2c0ad7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "custom",
      "poi_name": "CrossFit Fiend",
      "poi_type": "Gyms",
      "poi_address": "3901 N Tulsa Ave, Oklahoma City, OK 73112",
      "poi_short_description": "",
      "poi_long_description": "CrossFit Fiend Mission Statement At CrossFit Fiend, we empower individuals to achieve their fitness goals through a supportive and inclusive community. Our mission is to foster physical and mental growth, creating a united tribe that makes a positive impact both within our gym and on the broader community. We believe in meeting people where they are, helping them realize their potential, and inspiring them to thrive in every aspect of their lives.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a15543-24f3-7298-bf3e-fc1e56fe6172.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15543-24f3-7298-bf3e-fc1e56fe6172",
        "storage_key": "property/6767906449167856/01a15543-24f3-7298-bf3e-fc1e56fe6172.webp",
        "width": 666,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/crossfit-fiend-oklahoma-city?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=35.51019,-97.59282",
      "poi_item_slug": "crossfit-fiend-oklahoma-city",
      "poi_latitude": "35.51019",
      "poi_longitude": "-97.59282",
      "poi_miles_from_property": "5.26",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+14059216717",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJEzn4WOobsocRqOqvr5i2NC0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8adafd58-5683-4e2e-9076-8e2d494f853c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "custom",
      "poi_name": "Cleveland Elementary",
      "poi_type": "Elementary Schools",
      "poi_address": "2725 NW 23rd St, Oklahoma City, OK 73107",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.yelp.com/biz/cleveland-elementary-oklahoma-city?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=35.4932649,-97.5616933",
      "poi_item_slug": "cleveland-elementary-oklahoma-city",
      "poi_latitude": "35.4932649",
      "poi_longitude": "-97.5616933",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+14059451150",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJ9RUH8YUQsocRWol-qADNjYo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f23c20b5-a37b-4df0-b9d2-cb0f103d9fee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "custom",
      "poi_name": "Mount St. Mary Catholic High School",
      "poi_type": "High Schools",
      "poi_address": "2801 S Shartel Ave, Oklahoma City, OK 73109",
      "poi_short_description": "",
      "poi_long_description": "Principal: * Talita Denegri",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a15543-24e9-728c-bdee-c3792db0f56a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15543-24e9-728c-bdee-c3792db0f56a",
        "storage_key": "property/6767906449167856/01a15543-24e9-728c-bdee-c3792db0f56a.webp",
        "width": 1000,
        "height": 666
      },
      "poi_business_url": "https://www.yelp.com/biz/mount-st-mary-catholic-high-school-oklahoma-city?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=35.437226397332275,-97.52675577055096",
      "poi_item_slug": "mount-st-mary-catholic-high-school-oklahoma-city",
      "poi_latitude": "35.43722639733227",
      "poi_longitude": "-97.52675577055096",
      "poi_miles_from_property": "2.77",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+14056318865",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJYXzbJEsRsocRzTYSl5FcHaA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5c27e504-c17f-41db-afcc-0ab4c5c6c2aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "custom",
      "poi_name": "Bishop McGuinness Catholic High School",
      "poi_type": "High Schools",
      "poi_address": "801 NW 50th St, Oklahoma City, OK 73118",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a15543-29dc-751f-8ed8-159e435ac36f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15543-29dc-751f-8ed8-159e435ac36f",
        "storage_key": "property/6767906449167856/01a15543-29dc-751f-8ed8-159e435ac36f.webp",
        "width": 1000,
        "height": 739
      },
      "poi_business_url": "https://www.yelp.com/biz/bishop-mcguinness-catholic-high-school-oklahoma-city?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=35.52297975782659,-97.52754261428484",
      "poi_item_slug": "bishop-mcguinness-catholic-high-school-oklahoma-city",
      "poi_latitude": "35.52297975782659",
      "poi_longitude": "-97.52754261428484",
      "poi_miles_from_property": "3.46",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+14058426638",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJwV0C5R4asocRkj0QyRHUPgs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8dd8df61-946f-4163-8920-d6d517c75d1f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "custom",
      "poi_name": "Plenty Mercantile",
      "poi_type": "Shopping",
      "poi_address": "807 N Broadway Ave, Oklahoma City, OK 73102",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a15543-26a5-7719-a96a-68524d6d0e12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15543-26a5-7719-a96a-68524d6d0e12",
        "storage_key": "property/6767906449167856/01a15543-26a5-7719-a96a-68524d6d0e12.webp",
        "width": 666,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/plenty-mercantile-oklahoma-city-3?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=35.475332,-97.514587",
      "poi_item_slug": "plenty-mercantile-oklahoma-city-3",
      "poi_latitude": "35.475332",
      "poi_longitude": "-97.514587",
      "poi_miles_from_property": "0.25",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+14058887470",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ffbfcd55-f3f1-4395-b0e6-80d17848d8dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "custom",
      "poi_name": "Barkeep",
      "poi_type": "Shopping",
      "poi_address": "1121 N Walker Ave, Oklahoma City, OK 73102",
      "poi_short_description": "",
      "poi_long_description": "Welcome to barkeep OKC - the premier destination for all your bartending needs with a bar open to the public! Our bar store has everything you need to get your bar up and running and to create amazing cocktails. From cocktail supplies, to mixology classes, to a full service cocktail bar open late, we have it all. We take pride in stocking only the highest-quality products and our team of experienced staff are always on hand to offer advice and help you find the perfect supplies and ingredients. Whether you're a professional bartender or a home enthusiast, barkeep OKC is the perfect place to stock up on all the essentials. Visit today and let us help you get cocktail-ready! Barkeep is Oklahoma's #1 Cocktail Supply Shop and bar. Visit Today!",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a15543-26ca-724a-a33d-40fef417f133.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15543-26ca-724a-a33d-40fef417f133",
        "storage_key": "property/6767906449167856/01a15543-26ca-724a-a33d-40fef417f133.webp",
        "width": 753,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/barkeep-oklahoma-city?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=35.4795184270367,-97.5213146975532",
      "poi_item_slug": "barkeep-oklahoma-city",
      "poi_latitude": "35.4795184270367",
      "poi_longitude": "-97.5213146975532",
      "poi_miles_from_property": "0.71",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+14056044741",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJXe2LrZ4XsocRB3dGoAZOTwc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a8047f88-cd4a-4442-a2db-95cf8845ea54",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "custom",
      "poi_name": "The Sound Bar",
      "poi_type": "Shopping",
      "poi_address": "712B N Broadway Ave, Oklahoma City, OK 73102",
      "poi_short_description": "",
      "poi_long_description": "Oklahoma City’s premiere vinyl listening lounge in a comfortable loft setting. Superb hifi systems and 12,000 records for your listening pleasure and purchase in two listening rooms (large and small). Full bar for alcoholic and non alcoholic drinks, and you can bring dinner up from SAJ (downstairs Lebanese Restaurant). City views. Musical magic and great conversation is our hallmark.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a15543-2728-77cb-b53a-d8d3ce50ea4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15543-2728-77cb-b53a-d8d3ce50ea4b",
        "storage_key": "property/6767906449167856/01a15543-2728-77cb-b53a-d8d3ce50ea4b.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.yelp.com/biz/the-sound-bar-oklahoma-city-2?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=35.47457,-97.51383",
      "poi_item_slug": "the-sound-bar-oklahoma-city-2",
      "poi_latitude": "35.47457",
      "poi_longitude": "-97.51383",
      "poi_miles_from_property": "0.21",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+14054049832",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJYSZ6U88XsocRNgte8f7E2UI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_04416f11-b9a1-4a86-a45c-6e9ba649d463",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "custom",
      "poi_name": "Commonplace Books",
      "poi_type": "Shopping",
      "poi_address": "1325 N Walker Ave, Ste 138, Oklahoma City, OK 73103",
      "poi_short_description": "",
      "poi_long_description": "A thoughtful and curated selection of books from the classics to current events, a well designed and aesthetically inspiring place, a hospitable team with humility and heart that has a common love for books and people.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a15543-281d-7759-81fd-1de7e4f09c65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15543-281d-7759-81fd-1de7e4f09c65",
        "storage_key": "property/6767906449167856/01a15543-281d-7759-81fd-1de7e4f09c65.webp",
        "width": 1000,
        "height": 713
      },
      "poi_business_url": "https://www.yelp.com/biz/commonplace-books-oklahoma-city-2?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=35.482070395906696,-97.521292",
      "poi_item_slug": "commonplace-books-oklahoma-city-2",
      "poi_latitude": "35.4820703959067",
      "poi_longitude": "-97.521292",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+14055344540",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJnYrjczQXsocRxMt4DTeV5ng",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_be9b082c-ef06-4936-abc9-056e2fcc7bc9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "custom",
      "poi_name": "Holiday Pop-Up Shops",
      "poi_type": "Shopping",
      "poi_address": "399 NW 10th St, Oklahoma City, OK 73103",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a15543-281c-7472-a9ba-57c1adb0881f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15543-281c-7472-a9ba-57c1adb0881f",
        "storage_key": "property/6767906449167856/01a15543-281c-7472-a9ba-57c1adb0881f.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.yelp.com/biz/holiday-pop-up-shops-oklahoma-city?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=35.4782641,-97.5190986",
      "poi_item_slug": "holiday-pop-up-shops-oklahoma-city",
      "poi_latitude": "35.4782641",
      "poi_longitude": "-97.5190986",
      "poi_miles_from_property": "0.56",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJO2VwWjEXsocRNTSxKg-kgAk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_06922930-d027-49aa-8088-0b1b495e054c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "custom",
      "poi_name": "Oklahoma City National Memorial & Museum",
      "poi_type": "Entertainment",
      "poi_address": "620 N Harvey Ave, Oklahoma City, OK 73102",
      "poi_short_description": "",
      "poi_long_description": "America's remembrance of the 168 people killed here is magnified by this profoundly beautiful Memorial – and a Museum that exceeds all expectations. The Memorial is a place of quite reflection and the Museum, a place of transformation. In touchscreens, galleries and theaters, a powerful story unfolds – one that's as relevant today as ever. As is our mission to meet violence with vigilance. Free parking with Museum admission.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a15543-29d9-77ed-9dc4-f2a3f0282319.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15543-29d9-77ed-9dc4-f2a3f0282319",
        "storage_key": "property/6767906449167856/01a15543-29d9-77ed-9dc4-f2a3f0282319.webp",
        "width": 563,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/oklahoma-city-national-memorial-oklahoma-city?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=35.4736630319091,-97.517340834671",
      "poi_item_slug": "oklahoma-city-national-memorial-oklahoma-city",
      "poi_latitude": "35.4736630319091",
      "poi_longitude": "-97.517340834671",
      "poi_miles_from_property": "0.42",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+14052353313",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJq81FLi4XsocRDzJ3TUXPU0A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_67930ef8-49b4-4be2-bf30-c6a1c4778097",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "custom",
      "poi_name": "Myriad Botanical Gardens",
      "poi_type": "Entertainment",
      "poi_address": "301 W Reno Ave, Oklahoma City, OK 73102",
      "poi_short_description": "",
      "poi_long_description": "Myriad Botanical Gardens is one of Oklahoma City’s most beautiful and vibrant green spaces. Offering visitors a 15-acre natural escape in the heart in downtown, the Gardens are free and open to the public. Our spacious grounds feature seasonal activities and events such as spring bulb displays, concerts and movies, classes, annual children’s festivals, and more. The grounds are free to visit. The Inasmuch Crystal Bridge Conservatory requires admission to visit. Conservatory Admission Adult $10.50 Senior 62+ $9 Military/Veterans $9 Student $7 Youth (5-17 years) $5.50 Ages 4 & under FREE Myriad Gardens Members: FREE",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a15543-2b67-77ff-aede-38bee9e660da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15543-2b67-77ff-aede-38bee9e660da",
        "storage_key": "property/6767906449167856/01a15543-2b67-77ff-aede-38bee9e660da.webp",
        "width": 915,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/myriad-botanical-gardens-oklahoma-city?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=35.465340359554666,-97.5179000636787",
      "poi_item_slug": "myriad-botanical-gardens-oklahoma-city",
      "poi_latitude": "35.46534035955467",
      "poi_longitude": "-97.5179000636787",
      "poi_miles_from_property": "0.79",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+14054457080",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJA05XnykXsocR_K_5faGn0o8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2a0e7ef4-8c6e-406a-9a06-ed76baf9dcea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "custom",
      "poi_name": "Up-Down OKC",
      "poi_type": "Entertainment",
      "poi_address": "1629 NW 16th St, Oklahoma City, OK 73106",
      "poi_short_description": "",
      "poi_long_description": "We are a 21 and over Plaza District bar featuring over 40 craft beers on tap, fresh pizza by the slice, and 60 classic arcade games. Two stories of games with a bar on each and three outdoor patios.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a15543-2c40-7728-8150-08a90d2d8f03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15543-2c40-7728-8150-08a90d2d8f03",
        "storage_key": "property/6767906449167856/01a15543-2c40-7728-8150-08a90d2d8f03.webp",
        "width": 809,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/up-down-okc-oklahoma-city?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=35.48610611900104,-97.538163529445",
      "poi_item_slug": "up-down-okc-oklahoma-city",
      "poi_latitude": "35.48610611900104",
      "poi_longitude": "-97.538163529445",
      "poi_miles_from_property": "1.76",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+14056737792",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJCR5j4vgRsocR5zV2S1iVQIw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a9737cd7-1039-4db5-bee9-0579ed90f577",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "custom",
      "poi_name": "Civic Center Music Hall",
      "poi_type": "Entertainment",
      "poi_address": "201 N Walker Ave, Oklahoma City, OK 73102",
      "poi_short_description": "",
      "poi_long_description": "Oklahoma City's leading performing arts venue offering everything from Broadway to Ballet and more. Also speak to our Private Events Manager to book your wedding, corporate event, or private pre-show party!",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a15543-2b1e-73a1-bcd0-53a1f5e64296.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15543-2b1e-73a1-bcd0-53a1f5e64296",
        "storage_key": "property/6767906449167856/01a15543-2b1e-73a1-bcd0-53a1f5e64296.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.yelp.com/biz/civic-center-music-hall-oklahoma-city?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=35.4690606512972,-97.523133360292",
      "poi_item_slug": "civic-center-music-hall-oklahoma-city",
      "poi_latitude": "35.4690606512972",
      "poi_longitude": "-97.523133360292",
      "poi_miles_from_property": "0.84",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+14052972264",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJd_R4kSwXsocRZnawwf3tils",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5ef11dd1-e976-4242-851e-cdcc4bceedb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "custom",
      "poi_name": "Oklahoma City Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "415 Couch Dr, Oklahoma City, OK 73102",
      "poi_short_description": "",
      "poi_long_description": "OKCMOA is one of the leading arts institutions in the region. The Museum presents a dynamic range of exhibitions organized from prestigious museums and collections throughout the world. The Museum’s own diverse collection features highlights from North America, Europe and Asia, with strengths in American art and postwar abstraction. The permanent collection also boasts one of the world’s largest public collections of Dale Chihuly glass, a major collection of photography by Brett Weston and the definitive museum collection of works by painter Paul Reed. The Museum’s renowned Noble Theater screens the finest international, independent, documentary and classic films. Museum amenities include the Museum Store and Centre Bistro restaurant.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167856/01a15543-2cb6-738f-a46d-ea1c155e3135.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15543-2cb6-738f-a46d-ea1c155e3135",
        "storage_key": "property/6767906449167856/01a15543-2cb6-738f-a46d-ea1c155e3135.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.yelp.com/biz/oklahoma-city-museum-of-art-oklahoma-city?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=35.4696427719224,-97.5203945097975",
      "poi_item_slug": "oklahoma-city-museum-of-art-oklahoma-city",
      "poi_latitude": "35.4696427719224",
      "poi_longitude": "-97.5203945097975",
      "poi_miles_from_property": "0.68",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+14052363100",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJ__8_PiwXsocRSmdKhGQqB4Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_bedc0dd272f984078eda7b26",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_4d36cbb9cead0d10a8f253f6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "day": "WED",
      "open_time": "10:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_aa67e5a4ecc53b4614e70c23",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_6b087000d293b6286f969490",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_7cc416e52130c46c121fee2c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_fec7b5062c962fee30b7a2b6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_1d8fc90e-ad9d-478a-a4d2-6f300fc7a351",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "rating": "5",
      "name": "Jamie Gonzalez",
      "text": "I recently moved here and have been very impressed with the maintenance team. A special thanks to Isaac and the staff for their thorough work fixing my A/C. I especially appreciated Isaac following up afterward to make sure everything was working properly. Great service and attention to detail!",
      "date": "2026-06-23",
      "title": "false"
    },
    {
      "id": "custom_37995e70-0b54-4ff1-88a1-57cd77d273a4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "rating": "5",
      "name": "melody Phillips",
      "text": "I love living at The Met! It’s close to my job and there is a lot to do in the surrounding area.The staff (maintenance / front desk) are always so kind and helpful. My favorite part are the events that apartment life coordinators (Danielle & James ) host every month. It really brings the community together. I’ve never had this experience at any other apartment I’ve lived at. Thank you all!",
      "date": "2025-12-02",
      "title": "false"
    },
    {
      "id": "custom_a198af62-d09a-422b-96ac-9e478175b7e1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "rating": "5",
      "name": "victoria brito",
      "text": "Living at The Metropolitan has been a great experience. The atmosphere is welcoming, the community feels friendly, and the staff genuinely care about residents. Maintenance requests are handled efficiently.\n\nA special shoutout to Isaac, who consistently goes above and beyond. He is incredibly friendly, responsive, and always handles issues in a timely manner!",
      "date": "2026-04-14",
      "title": "false"
    },
    {
      "id": "custom_291dd405-3673-463d-a129-9cdecbe7d9a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "rating": "5",
      "name": "Shayla Harper",
      "text": "I would like to say that these apartments were hands down my favorite since living in okc for the past 7 years! I moved to the Metropolitan apartments last year of 2025 from the West Village, and I would say the staff and the apartments itself was well up-kept! The staff are great people and make sure you’re well taking care of . And don’t get me started on the maintenance crew. They helped me tremendously when it came to their responses and even the little things. The first floor ceiling height was a bonus to how big the apartment feel and look. Thank you metropolitan for the warm stay. I will be recommending these apartments to people looking to move downtown!",
      "date": "2026-05-01",
      "title": "false"
    },
    {
      "id": "custom_c208da70-8df6-4c46-bd71-951e01a7e5d4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "rating": "5",
      "name": "August",
      "text": "i only lived at the metropolitan for a year between 2022-2023 but it was the best place i’ve ever lived. i moved out of state to southern california but if i were to ever move back this would be my first choice to call home. i think about this place all the time. the apartments are spacious, they are clean and well taken care of and don’t receive “the landlord makeover” (the quick paint job, iykyk), the staff is friendly, the apartments are safe, the view is gorgeous. even living on the first floor against a main street i never had any break ins or stolen patio furniture. never had any issues with missing packages. never had any bug issues. maintenance was always wonderful and fast, the cleaners were absolutely amazing - this whole place was spotless and i always heard them vacuuming the hallways to keep them clean. the metropolitan is also extremely accessible if you are disabled, the doorways are wide enough to accommodate wheelchairs with extra space, there is an elevator, there are ramps any place there is stairs. the location is ideal as well, i feel like it’s far enough away from directly in downtown you don’t have to worry about more crime but there are still plenty of things within walking distance, including Parlor directly across the street (a food court style restaurant with several places to eat inside as well as a bar) and a wonderful little coffee shop called Junction Coffee just down the street. the metropolitan also always hosts community events for holidays where they provide meals or snacks, i know that’s random to mention but i’ve never experienced that anywhere else i’ve lived and i love that they do that. i know the apartments are a little pricey compared to other places in okc, but they are well worth it. (i’ve included some pictures i took from the roof of the metropolitan)",
      "date": "2024-04-25",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_a4dee879599ce31125e5223a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "NYC",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://player.vimeo.com/video/768232396?h=afebbc2ee6"
    },
    {
      "id": "ec_32bce5ac6b36f35abbf60293",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Los Angeles",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://player.vimeo.com/video/686012178?h=c304eabf8e"
    },
    {
      "id": "ec_84ee1251f3294cc623b417cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "San Antonio",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://player.vimeo.com/video/686011908?h=3d1cbf8ac3"
    },
    {
      "id": "ec_48d122fcbcf5fd2ffb41a9e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Chicago",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://player.vimeo.com/video/768310411?h=0679392414"
    },
    {
      "id": "ec_da8e0b67eb43941f4a83e64e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Phoenix",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://player.vimeo.com/video/768246366?h=6addf98ce9"
    },
    {
      "id": "ec_a3626f72cda2fd8bdcd3eb73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Dallas",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://player.vimeo.com/video/768242507?h=d3d616ac7d"
    },
    {
      "id": "ec_5cdd3fcc5a0557926ca7869d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Sacramento",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://player.vimeo.com/video/768243282?h=8970874eeb"
    },
    {
      "id": "ec_0e5389e8fb80206955a866a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Seattle",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://player.vimeo.com/video/686012354"
    },
    {
      "id": "ec_2f904b09e51e2bbb17e2f646",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Las Vegas",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://player.vimeo.com/video/781267986?h=be3684c0e0"
    },
    {
      "id": "ec_4e97a9a067b6181e011f692e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "San Diego",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://player.vimeo.com/video/686012540?h=871f6e95c8"
    },
    {
      "id": "ec_76eec4daf93d46b63a6743d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Charlotte",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://player.vimeo.com/video/686012023"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-oklahoma-city",
      "search_query": "apartments with in-unit laundry Oklahoma City",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in OKC",
      "h2_subtitle": "Discover Oklahoma City apartments with in-unit laundry at Metropolitan. Our feature-rich community offers modern amenities in Central Oklahoma City.",
      "page_copy": "If you're seeking apartments with in-unit laundry, look no further than Metropolitan in the heart of Oklahoma City. Located in Central Oklahoma City, this community offers a contemporary living experience complete with convenient amenities such as bicycle storage and recycling options. \n\nEnjoy the luxury of vaulted ceilings soaring up to 21', framed mirrors, and a dedicated playground area for the little ones. Experience a seamless blend of comfort and style while having the convenience of in-unit laundry to simplify your day-to-day routine. Join us at Metropolitan and elevate your living experience in Oklahoma City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167856/01a15536-897e-767e-a88c-0a085b095cbe.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and surrounding apartment buildings.",
        "public_id": "01a15536-897e-767e-a88c-0a085b095cbe",
        "storage_key": "property/6767906449167856/01a15536-897e-767e-a88c-0a085b095cbe.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments in Oklahoma City",
      "seo_description": "Metropolitan offers apartments with in-unit laundry in Oklahoma City featuring modern amenities. Enjoy convenience and style in Central OKC.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "generator",
      "page_item_url": "pet-friendly-dog-parks-oklahoma-county",
      "search_query": "pet friendly apartments with dog parks in Oklahoma County",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Oklahoma County",
      "h2_subtitle": "Discover pet-friendly apartments with dog parks in Oklahoma County at Metropolitan. Embrace a community tailored for you and your furry friend.",
      "page_copy": "For those seeking pet-friendly apartments with dog parks in Oklahoma County, Metropolitan offers the ideal living environment. This vibrant community in Central Oklahoma City provides ample amenities, including convenient bicycle storage, where both you and your pets can thrive. \n\nThe Metropolitan's design features remarkable vaulted ceilings, framed mirrors, and even a playground for all ages. Pets are considered family here, so enjoy the green spaces designed for walks and play. Discover the perfect blend of modern convenience and pet-friendly comfort at Metropolitan, where your pets are just as welcome as you are.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167856/01a15536-897e-767e-a88c-0a085b095cbe.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and surrounding apartment buildings.",
        "public_id": "01a15536-897e-767e-a88c-0a085b095cbe",
        "storage_key": "property/6767906449167856/01a15536-897e-767e-a88c-0a085b095cbe.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in Oklahoma County",
      "seo_description": "Find pet-friendly apartments with dog parks in Oklahoma County at Metropolitan. Enjoy amenities perfect for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "generator",
      "page_item_url": "luxury-apartments-central-okc-with-pools",
      "search_query": "luxury apartments with pools in Central Oklahoma City",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pools in Central OKC",
      "h2_subtitle": "Explore luxury living with pools in Central Oklahoma City. Metropolitan offers the perfect blend of style and comfort in an outstanding location.",
      "page_copy": "For those in search of luxury apartments with pools in Central Oklahoma City, Metropolitan presents an exceptional living experience. This premium community is nestled in the vibrant area of Central OKC, offering easy access to a host of amenities and local attractions. \n\nMetropolitan stands out with its stylish features like impressive 21' vaulted ceilings and elegant framed mirrors. While we emphasize luxury, the community is also practical with essential amenities like recycling and bicycle storage. Although our focus here is luxury, our community truly offers a comprehensive lifestyle waiting for you to explore.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167856/01a15536-897e-767e-a88c-0a085b095cbe.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and surrounding apartment buildings.",
        "public_id": "01a15536-897e-767e-a88c-0a085b095cbe",
        "storage_key": "property/6767906449167856/01a15536-897e-767e-a88c-0a085b095cbe.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pools in Central OKC",
      "seo_description": "Discover luxury apartments with pools at Metropolitan, Central OKC. Experience the ideal blend of comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "generator",
      "page_item_url": "air-conditioning-apartments-near-73104",
      "search_query": "apartments with air conditioning near 73104",
      "category": "Amenity",
      "h1_title": "Apartments with Air Conditioning Near 73104",
      "h2_subtitle": "Stay cool with air-conditioned apartments near the 73104 area. Discover what Metropolitan in Central Oklahoma City has to offer.",
      "page_copy": "Searching for apartments with air conditioning near 73104? Metropolitan is the perfect solution located in Central Oklahoma City. Our community provides a refreshing retreat with climate-controlled comfort, perfect for beating the Oklahoma heat.\n\nAlongside air conditioning, residents enjoy a wealth of amenities including expansive vaulted ceilings and options for recycling. Metropolitan also caters to active residents with bicycle storage and features framed mirrors that add a touch of elegance. Just a short distance from the happenings in OKC, our location offers the best in convenience and style.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167856/01a15536-897e-767e-a88c-0a085b095cbe.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and surrounding apartment buildings.",
        "public_id": "01a15536-897e-767e-a88c-0a085b095cbe",
        "storage_key": "property/6767906449167856/01a15536-897e-767e-a88c-0a085b095cbe.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air-Conditioned Apartments Near 73104",
      "seo_description": "Find air-conditioned apartments near 73104 at Metropolitan. Conveniently located in Central OKC with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "generator",
      "page_item_url": "dedicated-parking-garages-apartments-okc",
      "search_query": "apartments with dedicated parking and garages in Oklahoma City",
      "category": "Amenity",
      "h1_title": "Apartments with Parking & Garages in OKC",
      "h2_subtitle": "Discover apartments in Oklahoma City featuring dedicated parking and garages. Experience convenience and easy access at Metropolitan.",
      "page_copy": "If you're looking for apartments with dedicated parking and garages in Oklahoma City, Metropolitan offers a prime living option. Nestled in the heart of Central Oklahoma City, our community provides not just a home, but a lifestyle enriched with convenience and ease.\n\nWhile dedicated parking and secure garages ensure you have a stress-free arrival each day, our community also boasts impressive amenities like towering vaulted ceilings and playground facilities. With additional benefits like bicycle storage and recycling options, Metropolitan combines practical living with contemporary comfort in a superb location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167856/01a15536-897e-767e-a88c-0a085b095cbe.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and surrounding apartment buildings.",
        "public_id": "01a15536-897e-767e-a88c-0a085b095cbe",
        "storage_key": "property/6767906449167856/01a15536-897e-767e-a88c-0a085b095cbe.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "OKC Apartments with Parking & Garages",
      "seo_description": "Explore Oklahoma City apartments with dedicated parking and garages at Metropolitan. Experience a seamless, convenient lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-central-okc",
      "search_query": "one bedroom apartments central oklahoma city",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Central OKC",
      "h2_subtitle": "Find the perfect one-bedroom apartment in Central Oklahoma City. Metropolitan offers modern living in a vibrant neighborhood.",
      "page_copy": "Metropolitan provides an excellent choice for those seeking one-bedroom apartments in Central Oklahoma City. Our community, ideally located in this bustling area, delivers a blend of contemporary style and everyday convenience.\n\nEach one-bedroom apartment is designed with your comfort in mind, offering elegant features such as framed mirrors and lofty vaulted ceilings. Additionally, residents benefit from accessible amenities like bicycle storage and recycling services. With a prime location in Central OKC, you'll be close to all the best dining, shopping, and entertainment the city has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167856/01a15536-897e-767e-a88c-0a085b095cbe.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and surrounding apartment buildings.",
        "public_id": "01a15536-897e-767e-a88c-0a085b095cbe",
        "storage_key": "property/6767906449167856/01a15536-897e-767e-a88c-0a085b095cbe.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Central OKC",
      "seo_description": "Discover modern one-bedroom apartments in Central OKC at Metropolitan. Enjoy contemporary amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-73104",
      "search_query": "two bedroom apartments near 73104",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near 73104",
      "h2_subtitle": "Explore spacious two-bedroom apartments close to the 73104 area. Metropolitan offers a perfect blend of comfort and convenience.",
      "page_copy": "Looking for two-bedroom apartments near 73104? Metropolitan in Central Oklahoma City has you covered with spacious layouts ideal for both individuals and families. Enjoy the benefits of a well-designed floor plan that offers ample space and modern amenities.\n\nOur community, strategically located in Central OKC, provides easy access to the city's vibrant lifestyle hub. Alongside two-bedroom units, residents savor features like vaulted ceilings, playground facilities, and convenient bicycle storage. With such thoughtfully curated offerings, living at Metropolitan ensures a blend of luxury and functionality within reach of the 73104 area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167856/01a15536-897e-767e-a88c-0a085b095cbe.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and surrounding apartment buildings.",
        "public_id": "01a15536-897e-767e-a88c-0a085b095cbe",
        "storage_key": "property/6767906449167856/01a15536-897e-767e-a88c-0a085b095cbe.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious Two-Bedroom Apts Near 73104",
      "seo_description": "Discover two-bedroom apartments near 73104 at Metropolitan. Enjoy spacious living and convenient access in Central OKC.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "generator",
      "page_item_url": "apartments-near-rose-state-college-ok-county",
      "search_query": "apartments near Rose State College Oklahoma County",
      "category": "School",
      "h1_title": "Apartments Near Rose State College, OK County",
      "h2_subtitle": "Find comfortable living with convenient access to Rose State College. Metropolitan offers optimal apartment options in Central Oklahoma City.",
      "page_copy": "Metropolitan offers an ideal location for students and faculty seeking apartments near Rose State College in Oklahoma County. Situated in Central Oklahoma City, our community provides a quick and easy commute to the college while offering a comfortable and modern living experience.\n\nResidents at Metropolitan enjoy a variety of amenities, including vaulted ceilings that create a spacious feel, recycling options, and dedicated bicycle storage for those on the go. The community also features a playground, making it a great choice for families. Choose Metropolitan where convenience meets contemporary living, just a short drive from Rose State College.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167856/01a15536-897e-767e-a88c-0a085b095cbe.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and surrounding apartment buildings.",
        "public_id": "01a15536-897e-767e-a88c-0a085b095cbe",
        "storage_key": "property/6767906449167856/01a15536-897e-767e-a88c-0a085b095cbe.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Rose State College, OK County",
      "seo_description": "Discover convenient apartments near Rose State College in Oklahoma County. Metropolitan offers modern living in Central OKC.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "generator",
      "page_item_url": "oklahoma-city-university-nearby-apartments",
      "search_query": "Oklahoma City University nearby apartments",
      "category": "School",
      "h1_title": "Apartments Near Oklahoma City University",
      "h2_subtitle": "Experience ideal living close to Oklahoma City University. Metropolitan offers fantastic apartment options for students and faculty.",
      "page_copy": "For those attending or working at Oklahoma City University, finding convenient nearby apartments is a breeze with Metropolitan. Located in Central Oklahoma City, our community offers a perfect blend of proximity and comfort, making it an ideal choice for university life.\n\nOur apartments boast modern amenities such as vaulted ceilings and framed mirrors, providing a contemporary atmosphere. Residents also benefit from bicycle storage and recycling facilities, adding convenience to everyday living. Metropolitan creates a welcoming environment with plenty of recreational options, including a playground, all within easy reach of the university. Choose Metropolitan for a delightful living experience within minutes of Oklahoma City University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167856/01a15536-897e-767e-a88c-0a085b095cbe.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and surrounding apartment buildings.",
        "public_id": "01a15536-897e-767e-a88c-0a085b095cbe",
        "storage_key": "property/6767906449167856/01a15536-897e-767e-a88c-0a085b095cbe.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Oklahoma City University",
      "seo_description": "Find comfortable and modern living at Metropolitan, offering nearby apartments ideal for Oklahoma City University students and staff.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "generator",
      "page_item_url": "apartments-close-to-oklahoma-state-university-okc",
      "search_query": "apartments close to Oklahoma State University OKC",
      "category": "School",
      "h1_title": "Apartments Close to Oklahoma State University OKC",
      "h2_subtitle": "Discover convenient living near Oklahoma State University OKC. Metropolitan provides excellent apartment options just a short drive away.",
      "page_copy": "Metropolitan is the perfect choice for anyone seeking apartments close to Oklahoma State University OKC. Situated in Central Oklahoma City, our community offers quick access to campus while providing a comfortable and contemporary living environment.\n\nResidents enjoy a range of amenities designed for convenience and luxury, such as impressive vaulted ceilings and stylish framed mirrors that enhance your living space. Additionally, facilities like bicycle storage and recycling make Metropolitan an eco-friendly choice. With a playground available, our community is also family-friendly. Enjoy the ideal blend of location and amenities at Metropolitan, near Oklahoma State University OKC.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167856/01a15536-897e-767e-a88c-0a085b095cbe.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and surrounding apartment buildings.",
        "public_id": "01a15536-897e-767e-a88c-0a085b095cbe",
        "storage_key": "property/6767906449167856/01a15536-897e-767e-a88c-0a085b095cbe.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Oklahoma State University OKC",
      "seo_description": "Metropolitan offers modern living close to Oklahoma State University OKC. Enjoy a quick commute and comfortable amenities in Central OKC.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "generator",
      "page_item_url": "apartments-near-ou-health-university-oklahoma-medical-center",
      "search_query": "apartments near OU Health University of Oklahoma Medical Center Central Oklahoma City",
      "category": "Hospital",
      "h1_title": "Apts Near OU Health University Medical Center",
      "h2_subtitle": "Find convenient living near OU Health University of Oklahoma Medical Center. Metropolitan offers ideal apartment options in Central Oklahoma City.",
      "page_copy": "At Metropolitan, you can experience the convenience of living near OU Health University of Oklahoma Medical Center, located right in Central Oklahoma City. Our community provides the perfect location for students, staff, and medical professionals seeking nearby apartments with modern comforts.\n\nOur residents enjoy high ceilings that create a spacious atmosphere, and practical amenities like recycling and bicycle storage enhance their daily lives. Metropolitan is family-friendly, featuring a playground and other community facilities. With easy access to the Medical Center, Metropolitan is an excellent choice for those wanting proximity without compromising on residential quality.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167856/01a15536-897e-767e-a88c-0a085b095cbe.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and surrounding apartment buildings.",
        "public_id": "01a15536-897e-767e-a88c-0a085b095cbe",
        "storage_key": "property/6767906449167856/01a15536-897e-767e-a88c-0a085b095cbe.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near OU Health University Medical Center",
      "seo_description": "Discover comfortable living near OU Health University of Oklahoma Medical Center at Metropolitan, located in Central Oklahoma City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "generator",
      "page_item_url": "apartments-near-scissortail-park-oklahoma-city",
      "search_query": "apartments near Scissortail Park Oklahoma City",
      "category": "Park",
      "h1_title": "Apts Near Scissortail Park Oklahoma City",
      "h2_subtitle": "Enjoy vibrant living near Scissortail Park. Metropolitan offers great apartment options just minutes away in Central Oklahoma City.",
      "page_copy": "The Metropolitan is your go-to choice for apartments near Scissortail Park in Oklahoma City. Nestled in Central Oklahoma City, our location offers both the tranquility of park-side living and the convenience of urban access.\n\nResidents benefit from modern features like lofty vaulted ceilings and elegant framed mirrors that elevate the living experience. Bicycle storage and recycling options contribute to a sustainable lifestyle without compromising on modern comforts. With Scissortail Park nearby, residents can relish outdoor activities and beautiful green spaces while staying connected to the city hub. Choose Metropolitan for unmatched living by Scissortail Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167856/01a15536-897e-767e-a88c-0a085b095cbe.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and surrounding apartment buildings.",
        "public_id": "01a15536-897e-767e-a88c-0a085b095cbe",
        "storage_key": "property/6767906449167856/01a15536-897e-767e-a88c-0a085b095cbe.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Scissortail Park Oklahoma City",
      "seo_description": "Live near Scissortail Park at Metropolitan, offering modern apartments with exceptional amenities in Central Oklahoma City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "generator",
      "page_item_url": "apartments-close-to-myriad-botanical-gardens-ok",
      "search_query": "apartments close to Myriad Botanical Gardens OK",
      "category": "Park",
      "h1_title": "Apts Close to Myriad Botanical Gardens OK",
      "h2_subtitle": "Find serene living near Myriad Botanical Gardens. Metropolitan offers prime apartment options nearby in Central Oklahoma City.",
      "page_copy": "Metropolitan provides the ideal location for those looking to live near the lush landscapes of Myriad Botanical Gardens in Oklahoma City. In the heart of Central Oklahoma City, our community offers a peaceful retreat with the convenience of urban life.\n\nBoasting features like 11' and 21' vaulted ceilings, our apartments promise a spacious and airy feel. Residents also enjoy eco-friendly amenities such as recycling and bicycle storage. A playground ensures family-friendly fun, while the proximity to Myriad Botanical Gardens means residents can easily enjoy nature's beauty whenever they wish. Choose Metropolitan for both location and lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167856/01a15536-897e-767e-a88c-0a085b095cbe.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and surrounding apartment buildings.",
        "public_id": "01a15536-897e-767e-a88c-0a085b095cbe",
        "storage_key": "property/6767906449167856/01a15536-897e-767e-a88c-0a085b095cbe.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close to Myriad Botanical Gardens OK",
      "seo_description": "Metropolitan offers modern living near Myriad Botanical Gardens with luxurious amenities in Central Oklahoma City, perfect for nature enthusiasts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "generator",
      "page_item_url": "metropolitan-proximity-to-will-rogers-gardens-ok",
      "search_query": "Metropolitan proximity to Will Rogers Gardens OK",
      "category": "Park",
      "h1_title": "Metropolitan Near Will Rogers Gardens OK",
      "h2_subtitle": "Experience tranquil living near Will Rogers Gardens, with Metropolitan offering prime apartment options close by in Central Oklahoma City.",
      "page_copy": "Discover the bliss of living near Will Rogers Gardens when you choose the Metropolitan in Central Oklahoma City. Our proximity to this beautiful greenspace allows residents to enjoy serene surroundings without straying far from urban amenities.\n\nMetropolitan features residences with impressive vaulted ceilings, contributing to a spacious living environment. With amenities like bicycle storage and recycling, we focus on fostering a community that values both convenience and sustainability. Families will appreciate the on-site playground, while everyone can enjoy quick access to the gardens for leisurely walks or weekend picnics. Embrace the ideal blend of nature and city living at Metropolitan.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167856/01a15536-897e-767e-a88c-0a085b095cbe.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and surrounding apartment buildings.",
        "public_id": "01a15536-897e-767e-a88c-0a085b095cbe",
        "storage_key": "property/6767906449167856/01a15536-897e-767e-a88c-0a085b095cbe.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Metropolitan Near Will Rogers Gardens OK",
      "seo_description": "Metropolitan offers perfect living near Will Rogers Gardens, combining tranquility with city convenience in Central Oklahoma City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162483",
      "property_id": "6767906449167856",
      "source": "generator",
      "page_item_url": "central-oklahoma-city-apartments-bricktown-river-walk",
      "search_query": "Central Oklahoma City apartments by Bricktown River Walk Park",
      "category": "Park",
      "h1_title": "Apts by Bricktown River Walk Park OKC",
      "h2_subtitle": "Discover vibrant living by Bricktown River Walk Park. Metropolitan offers exceptional apartment options in the heart of Central Oklahoma City.",
      "page_copy": "The Metropolitan presents an unparalleled apartment experience near Bricktown River Walk Park in Central Oklahoma City. This prime location captures the vibrancy of the city while providing easy access to scenic river views and lively entertainment options.\n\nOur community boasts apartments with elegant features like vaulted ceilings and framed mirrors, offering a luxurious living atmosphere. Residents also enjoy practical amenities such as secure bicycle storage and dedicated recycling services, making sustainable living effortless. The nearby Bricktown River Walk Park offers an inviting escape for relaxation and recreation, making the Metropolitan the perfect choice for those seeking both excitement and comfort in their city lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167856/01a15536-897e-767e-a88c-0a085b095cbe.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and surrounding apartment buildings.",
        "public_id": "01a15536-897e-767e-a88c-0a085b095cbe",
        "storage_key": "property/6767906449167856/01a15536-897e-767e-a88c-0a085b095cbe.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts by Bricktown River Walk Park OKC",
      "seo_description": "Experience city living near Bricktown River Walk Park at Metropolitan, offering luxury apartments and modern amenities in Central Oklahoma City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "4780"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9147445652"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=4057594863"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NSKFGNDJ"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 7"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "0244e378-20fa-4639-ad10-02b9a894a82c"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Roxanne"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/690632b0-7208-48ee-995e-c2af8c5ec90d/app.js?property=690632b0-7208-48ee-995e-c2af8c5ec90d&amp;propertyName=Metropolitan&amp;channelUuid=c248ec55-8dac-11ec-afb4-42010aa8d42b\" defer=\"\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImpTVUs4cytIajYxQlNoSmVyK3ptcHc9PSIsInZhbHVlIjoiTEp1azRCd2kvVUVKZ0xyMFBWYXVsUT09IiwibWFjIjoiMTAzYzcwZTBjZTcyZjkxOGM1Yjg2NzQyYTBlN2EzOWM5MmE1ZjNjMGQ5YjA4YzhiNzljODI3NzEwMmJmYTFiZSJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_qb_id": "4780",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "9147445652",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=4057594863",
  "custom_google_gtm_id": "GTM-NSKFGNDJ",
  "custom_rollout_phase": "Phase 7",
  "custom_rentgrata_token": "0244e378-20fa-4639-ad10-02b9a894a82c",
  "custom_vibesites_theme": "Roxanne",
  "custom_ads_subscription": "none",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/690632b0-7208-48ee-995e-c2af8c5ec90d/app.js?property=690632b0-7208-48ee-995e-c2af8c5ec90d&amp;propertyName=Metropolitan&amp;channelUuid=c248ec55-8dac-11ec-afb4-42010aa8d42b\" defer=\"\"></script>",
  "custom_seo_subscription": "none",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImpTVUs4cytIajYxQlNoSmVyK3ptcHc9PSIsInZhbHVlIjoiTEp1azRCd2kvVUVKZ0xyMFBWYXVsUT09IiwibWFjIjoiMTAzYzcwZTBjZTcyZjkxOGM1Yjg2NzQyYTBlN2EzOWM5MmE1ZjNjMGQ5YjA4YzhiNzljODI3NzEwMmJmYTFiZSJ9"
};

export const generatedAt = '2026-10-20T04:48:16.856Z';
